import { Textarea, TextareaProps } from '@mantine/core'

interface TextAreaInputProps extends TextareaProps {
  editing?: boolean
  value?: string
  handleChange?: (value: string) => void
}

const TextAreaInput = ({ editing, value, handleChange, ...props }: TextAreaInputProps) => {
  return (
    <Textarea
      variant={editing ? 'default' : 'unstyled'}
      classNames={{
        label: 'text-sm font-medium text-doubleNickel-gray-700',
        input: `cursor-pointer whitespace-pre-wrap text-sm text-doubleNickel-gray-900 ${
          editing ? 'caret-inherit' : 'caret-transparent'
        } [&[data-disabled]]:bg-doubleNickel-white [&[data-disabled]]:opacity-100 [&[data-disabled]]:text-doubleNickel-gray-600`,
      }}
      value={value ?? '-'}
      autosize
      readOnly={!editing}
      onChange={(event) => {
        if (editing) {
          if (handleChange) {
            handleChange(event.currentTarget.value)
          } else if (props.onChange) {
            props.onChange(event)
          }
        }
      }}
      onClick={(event) => {
        if (editing) {
          event.stopPropagation()
        }
      }}
      {...props}
    />
  )
}

export default TextAreaInput
